<template>
  <article>
    <group gutter="0px">
      <cell title="战败原因" primary="content" @click.native='onCheck' class="status-left car-info-sel" is-link>
        <!-- <p slot="value" style="color: #a0a0a0;">请选择</p> -->
        <p slot="value" class="car-info">{{failText}}</p>
      </cell>
    </group>
    <popup v-model="isShow" style="height: 100%;overflow: auto;">
      <group title="战败原因">
        <checker v-model="failText" style="margin-right: 0;">
          <checker-item class="appointment-item" v-for="(item,index) in failReason" :key="index" :value="item.value" @on-item-click="onSelectAdvisor(item)">
            <cell class="appointment-adviser" :title="item.value">
              <icon type="success_no_circle" v-if="failText === item.value"></icon>
            </cell>
          </checker-item>
        </checker>
      </group>
    </popup>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="toSave">确认提交</a>
      </div>
    </section>
  </article>
</template>
<script>
import {
  Icon,
  Popup,
  Checker,
  CheckerItem,
  Cell,
  Group
} from '@lx-frontend/cvux'

export default {
  components: {
    Icon,
    Popup,
    Checker,
    CheckerItem,
    Cell,
    Group
  },
  data () {
    return {
      customer_id: '',
      failText: '',
      failId: '',
      failReason: [],
      isShow: false
    }
  },
  created () {
    this.$rest.saleManage.getEnums().then(res => {
      this.failReason = res.data.fail_reason
      this.customer_id = this.$route.params.id
    })
  },
  methods: {
    toSave () {
      if (!this.failId) {
        this.showToast('请选择战败原因')
        return false
      }
      this.$rest.saleManage.applyFail({
        customer_id: parseInt(this.customer_id),
        fail_reason: parseInt(this.failId)
      }).then(res => {
        if (res.code === 0) {
          this.showToast('提交成功')
          this.$router.go(-1)
        } else {
          this.showToast(res.message)
        }
      })
    },
    onCheck () {
      this.isShow = !this.isShow
    },
    onSelectAdvisor (item) {
      // 员工名字展示
      // 勾选显示
      this.failText = item.value
      this.failId = item.key
      // 关闭列表
      this.isShow = false
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
